import * as React from "react";
function SvgGeomark2(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M16 30Q4.47 19.89 4.47 13.53a11.53 11.53 0 0123.06 0Q27.53 19.89 16 30zm0-12.35a4.95 4.95 0 10-4.94-4.94A4.94 4.94 0 0016 17.65z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgGeomark2);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
